module.exports = __webpack_public_path__ + "images/ce8eec422c142ebee7b011fd47c358d7.webp";